export default class LeaderboardBestScores {
    constructor() {
        this.contest_task_id = 0;
        this.selected_range = 4; // Default to absolute
        this.bindEvents();
    }

    bindEvents() {
        let self = this;
        $(".js-filter-best-scores").unbind("click").click(function (e) {
            e.preventDefault();
            self.setFilter(this);
        })
    }


    onDataChanged(data){
        this.contest_task_id = data.contest_task_id;
        this.reloadScores();
    }

    onDestroy(){
        $(".js-filter-best-scores").unbind("click")
    }


    reloadScores() {
        $.ajax({
            url: '/contest_task/ajax_leaderboard_best_scores/'+ this.contest_task_id,
            type: "get",
            data: {
                selected_range: this.selected_range
            },
            success: function(html) {
                $("#scores-container").empty();
                $("#scores-container").append(html);
                $("#score-loader").removeClass("d-flex");
                $("#score-loader").addClass("d-none");
            },
            error: function(data) {
            }
        });
    }

    setFilter(item) {
        let newFilter = parseInt($(item).data("id"))
        if (this.selected_range !== newFilter){
            this.selected_range = newFilter;
            $("#js-best-scores-btn-span").text($(item).data("name"));
            this.reloadScores()
        }
    }
}
